/* eslint-disable import/prefer-default-export */
export function getImageLinkByOrigin(productOrigin) {
  if (productOrigin === 'Belenus' || productOrigin === 'fixadores') {
    return 'https://storage.googleapis.com/fotos-prd/';
  }

  return process.env.VUE_APP_FOTOS_URL;
}
